class CalendarDeliveryScheduler {
  constructor({ input, deliveryRoutes, hasRestrictedItem, christmasDate, calendarOptions, onChange }) {
    this.routes = deliveryRoutes;
    this.hasRestrictedItem = hasRestrictedItem;
    this.christmasDate = christmasDate;

    this.dateRouteMap = {};
    this.dropoffRouteMap = {};
    Object.entries(deliveryRoutes).forEach(([routeName, routeData]) => {
      (routeData.dropoffPoints || []).forEach((point) => {
        this.dropoffRouteMap[point] = routeName;
      });
    });

    this.picker = flatpickr(input, {
      ...calendarOptions,
      onChange: (selectedDates, dateStr) => onChange(selectedDates, dateStr),
    });
  }

  matchRouteByDropoffName(fullName) {
    return this.dropoffRouteMap[fullName] || null;
  }

  matchRoutesByPostalCode(code) {
    return Object.keys(this.routes).filter((routeName) =>
      (this.routes[routeName].postalCodes || [])
        .map((c) => c.trim())
        .includes(code),
    );
  }

  getEffectiveRouteDates(route) {
    const now = new Date();
    const availableDates = (route.dates || []).filter((date) => {
      const cutoff = route.cutoffs[date];
      return !cutoff || now <= new Date(cutoff);
    });

    return this.hasRestrictedItem
      ? availableDates.filter((date) => date >= this.christmasDate)
      : availableDates;
  }

  getNextAvailableDate(route) {
    const dates = this.getEffectiveRouteDates(route);
    return [...dates].sort()[0] || null;
  }

  applyRoute(routeName) {
    return this.applyRoutes([routeName]);
  }

  getRouteForDate(dmyDate) {
    return this.dateRouteMap[dmyDate] || null;
  }

  // Returns true if dates were applied, false if no route has any available
  applyRoutes(routeNames) {
    this.dateRouteMap = {};
    const effectiveDates = [];

    routeNames.forEach((routeName) => {
      const route = this.routes[routeName];
      if (!route) return;
      this.getEffectiveRouteDates(route).forEach((date) => {
        effectiveDates.push(date);
        const dmy = CalendarUtils.ymdToDmy(date);
        if (!this.dateRouteMap[dmy]) this.dateRouteMap[dmy] = routeName;
      });
    });

    if (effectiveDates.length === 0) {
      this.clear();
      return false;
    }

    const formattedDates = [...new Set(effectiveDates)].map(CalendarUtils.ymdToDmy);
    this.picker.set("enable", formattedDates);
    this.picker.clear();

    const earliestDate = CalendarUtils.getEarliestDate(effectiveDates);
    const firstAvailableDate = this.hasRestrictedItem
      ? CalendarUtils.ymdToDmy(earliestDate > this.christmasDate ? earliestDate : this.christmasDate)
      : CalendarUtils.ymdToDmy(earliestDate);

    this.picker.set("minDate", firstAvailableDate);
    this.picker.set("maxDate", CalendarUtils.ymdToDmy(CalendarUtils.getLatestDate(effectiveDates)));
    this.picker.redraw();

    return true;
  }

  clear() {
    this.picker.clear();
  }

  reset() {
    this.picker.set("maxDate", this.hasRestrictedItem ? this.christmasDate : null);
    this.picker.clear();
  }

  setMinMax(minDate, maxDate) {
    this.picker.set("minDate", minDate);
    this.picker.set("maxDate", maxDate);
  }

}
